export default [

     {
          path: '/glossary-update-request',
          name: 'GlossaryUpdateRequest',
          component: () => import("@/views/Page/GlossaryUpdateRequest/GlossaryUpdateRequest.vue"),
           meta: {
               title: '#Default# | GlossaryUpdateRequest',
          },
     }
];